import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import PipelineStatusDomainService from "../../../Domain/PipelineStatus/PipelineStatus.service";
const PipelineStatusBadge = ({ pipelineStatus, className, }) => {
    const color = PipelineStatusDomainService.getColor(pipelineStatus.id);
    return (_jsx("span", { className: `badge badge-${color} ${className || ""}`, children: pipelineStatus.name }));
};
export default PipelineStatusBadge;
